import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBlock: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="block, workspace">
      <path
        d="M5 20V4H19V20M5 20H19M5 20H3M19 20H21M9 8H10M14 8H15M9 12H10M14 12H15M9 16H10M14 16H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </CentralIconBase>
  );
};

export default IconBlock;
